import React from 'react'
import { string } from 'prop-types'
import { Form, TextInput } from '@cobalt/cobalt-react-components'
import {
  ACCEPT_INVITATION_FORM_NAME,
  ACCEPT_INVITATION_FORM_EMAIL
} from '../../constants/ui.labels'

const AcceptInvitationForm = ({ name, email }) => (
  <React.Fragment>
    <Form.Field label={ACCEPT_INVITATION_FORM_NAME} disabled>
      <TextInput value={name} />
    </Form.Field>
    <Form.Field label={ACCEPT_INVITATION_FORM_EMAIL} disabled>
      <TextInput value={email} />
    </Form.Field>
  </React.Fragment>
)

AcceptInvitationForm.propTypes = {
  name: string.isRequired,
  email: string.isRequired
}

export default AcceptInvitationForm
